import React from 'react';
import { useTranslation } from 'react-i18next';
import { Divider } from '../common/Divider';
import { OperationSettlementStatusBar } from './OperationSettlementStatusBar';
import SVGImage from '../layout/SVGImage';
import { OperationSettlementSummaryStatementCard } from './OperationSettlementSummaryStatementCard';
import { testSettlementSummaryCardData } from '@/utils/data';
import { OperationSettlementSummaryButton } from './OperationSettlementSummaryButton';

interface OperationSettlementSummaryModalProps {
  testId?: string;
  className?: string;
  title?: string;
  onClick?: () => void;
}

export const OperationSettlementSummaryModal: React.FC<
  OperationSettlementSummaryModalProps
> = ({ testId, className, title, onClick }) => {
  const { t } = useTranslation();
  return (
    <div
      className={`flex flex-col items-end ${className}`}
      data-testid={testId}
    >
      <SVGImage
        className="mb-[15px] cursor-pointer"
        testId={`${testId}-close-button`}
        name="cancle"
        onClick={onClick}
      />
      <div
        className={`w-full ${className} bg-white p-[38px] pt-[36px] shadow-8`}
      >
        {/* 정산 요약 */}
        <p className="text-dart-3 noto-semibold-4 leading-[23px]">{`${title} ${t('settlement.settlementSummary')}`}</p>
        <Divider className="mt-[16px] bg-[#D6DEE4]" />
        {/* 진행현황 */}
        <p className="noto-13-semibold mt-[15px] leading-[23px] text-dark-3">
          {t('settlement.currentStatus')}
        </p>
        <OperationSettlementStatusBar className="mt-[10px]" />
        <Divider className="mt-[20px] bg-[#D6DEE4]" />
        {/* 정산서 */}
        <p className="noto-13-semibold mt-[14px] text-dark-3">
          {t('settlement.settlementStatement')}
        </p>
        <OperationSettlementSummaryStatementCard
          title="발전 실적"
          data={testSettlementSummaryCardData}
          className="mt-[10px]"
        />
        <OperationSettlementSummaryStatementCard
          title="수익 정산"
          data={testSettlementSummaryCardData}
          className="mt-[15px]"
        />
        <Divider className="mt-5 bg-[#D6DEE4]" />
        {/* 메모 */}
        <p className="noto-13-semibold mt-[15px] leading-[23px] text-dark-3">
          {t('settlement.memo')}
        </p>
        <textarea
          className="noto-normal-3 mt-[5px] h-[66px] w-full resize-none rounded-[5px] border border-light-6 bg-white p-[10px] leading-none placeholder:text-light-5 focus:outline-none"
          data-testid={`${testId}-body`}
          onChange={() => {}}
          placeholder={t('overview.modal.memo', { context: 'placeholder' })}
        ></textarea>
        <Divider className="my-5 bg-[#3F4C5A]" />
        <div className="flex justify-between">
          <OperationSettlementSummaryButton text="다운로드" isClicked={false} />
          <OperationSettlementSummaryButton
            text="정산 완료"
            isClicked={false}
          />
        </div>
      </div>
    </div>
  );
};
